import { authService } from '../../services/auth/authService';
import type { FirebaseLoginResult } from '../../entities/auth/firebaseLoginResult';

/**
 * SignInWithEmailUseCase
 *
 * DEV-ONLY QA tooling: runs the Firebase email/password sign-in and returns
 * the raw FirebaseLoginResult. The presentation form that calls this is gated
 * behind `import.meta.env.DEV`. Mirrors the two-step login shape of the
 * Google/Apple use cases: the caller is responsible for calling
 * `SaveUserUseCase` next. No Flutter parity dimension — web QA affordance only.
 */
export class SignInWithEmailUseCase {
    async execute(email: string, password: string): Promise<FirebaseLoginResult> {
        return await authService.signInWithEmailAndPassword(email, password);
    }
}

export const signInWithEmailUseCase = new SignInWithEmailUseCase();
